"use strict";
var Provider = (function () {
    function Provider() {
    }
    return Provider;
}());
exports.Provider = Provider;
//# sourceMappingURL=D:/a/1/s/typeahead/src/models/provider.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/typeahead/src/models/provider.model.js